// extracted by mini-css-extract-plugin
var _1 = "Statuses-modulerightMargin__j1KwO";
export { _1 as "rightMargin" }
